import { render, staticRenderFns } from "./DamagesSynthesisQuestion.vue?vue&type=template&id=76f18413"
import script from "./DamagesSynthesisQuestion.vue?vue&type=script&lang=ts"
export * from "./DamagesSynthesisQuestion.vue?vue&type=script&lang=ts"
import style0 from "./DamagesSynthesisQuestion.vue?vue&type=style&index=0&id=76f18413&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports